import * as React from 'react';

import { LocalizedText } from '@shared-ui/localization-context';

import { UitkSpacing } from 'uitk-react-spacing';

import { SharedUiLodgingOneKeyBurnSwitchWrapper } from '../shared-ui/offers/lodging-one-key-burn-switch-wrapper';
import { SharedUiSingleUnitForm } from '../shared-ui/form/shared-ui-forms';

export interface SearchWizardComposerProps {
  navigateTo?: (...args: any) => void;
  onUpdateResults?: (...args: any) => void;
}

export const SearchWizardComposer: React.FunctionComponent<SearchWizardComposerProps> = ({ navigateTo, onUpdateResults }) => (
  <UitkSpacing padding={{ block: 'three' }}>
    <div data-stid="single-offer-search">
      <h3 className="is-visually-hidden">
        <LocalizedText message={'hotels.infosite.availabilityWizard.changeSearch.a11yLabel'} />
      </h3>
      <SharedUiSingleUnitForm onSubmit={navigateTo} onChange={onUpdateResults} />
      <SharedUiLodgingOneKeyBurnSwitchWrapper showBorder={true} />
    </div>
  </UitkSpacing>
);

SearchWizardComposer.displayName = 'SearchWizardComposer';
